// Meta billing rules shared by the billing screen. Tools no longer debits anyone: the payment
// method is informative and direct debits are scheduled by hand in Pennylane after billing.

const PAYMENT_MODE_TAGS = {
    pro_account_sepa_core: { className: "credit", label: "Prélèvement Pennylane" },
    offline: { className: "purple", label: "Virement" },
    gocardless_direct_debit: { className: "waiting", label: "GoCardless (à migrer)" },
};

const UNKNOWN_PAYMENT_MODE_TAG = { className: "default", label: "Inconnu" };

// Payment method actually used by an invoice (stored at billing time, recovered from Pennylane for the history)
const INVOICED_PAYMENT_MODE_TAGS = {
    ...PAYMENT_MODE_TAGS,
    gocardless_direct_debit: { className: "credit", label: "Prélèvement GoCardless" },
};

const NOT_SPECIFIED_PAYMENT_MODE_TAG = { className: "default", label: "Non renseigné" };

export const getPaymentModeTag = (paymentMethod) => PAYMENT_MODE_TAGS[paymentMethod] || UNKNOWN_PAYMENT_MODE_TAG;

// Invoiced row: the payment method actually used; row to invoice: the one planned by the current subscription
export const getRowPaymentMode = (client) => {
    if (!client.hasInvoice) return { ...getPaymentModeTag(client.paymentMethod), invoiceNumber: null };
    const tag = INVOICED_PAYMENT_MODE_TAGS[client.invoicePaymentMethod] || NOT_SPECIFIED_PAYMENT_MODE_TAG;
    return { ...tag, invoiceNumber: client.invoiceNumber || null };
};

export const isClientBillable = (client, isBillable) => Boolean(isBillable && !client.hasInvoice && client.billingCost > 0);

// A Pennylane debit cannot be scheduled without a valid pro account mandate (null = Pennylane unavailable)
export const needsMandateWarning = (client) => !client.hasInvoice && client.paymentMethod === "pro_account_sepa_core" && client.proMandateStatus !== "valid";

const formatEuros = (amount) =>
    Number(amount).toLocaleString("fr-FR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

export const buildDebitList = (batchClients, batchStatus) =>
    batchClients
        .filter((client) => client.paymentMethod !== "offline" && batchStatus[client.id]?.status === "success")
        .map((client) => {
            const result = batchStatus[client.id].result;
            return {
                name: client.contact?.data?.customer_name,
                invoiceNumber: result.invoiceNumber,
                amountTTC: result.amountTTC,
                recovered: result.status === "recovered",
            };
        });

export const formatDebitListForCopy = (rows) => rows.map((row) => `${row.name}\t${row.invoiceNumber}\t${formatEuros(row.amountTTC)} €`).join("\n");
